module.exports = __webpack_public_path__ + "img/guanzhu.12786577.png";